import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FactAnimation from './FactAnimation';
import LazyAnimation from './LazyAnimation';

const useStyles = makeStyles(theme => ({
  wrapper: {
    backgroundColor: '#F7F7F7',
    paddingTop: 120,
    paddingBottom: 120,
  },
  container: {
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    fontFamily: 'PoppinsSemiBold',
    fontWeight: '600',
    fontSize: 30,
    lineHeight: '1.4em',
    textAlign: 'center',
    paddingBottom: 10,
    color: '#333333',
  },
  body: {
    maxWidth: 800,
    marginLeft: 'auto',
    marginRight: 'auto',
    fontWeight: '300',
    textAlign: 'center',
    fontSize: 18,
    lineHeight: '1.8em',
    paddingBottom: '1em',
    fontFamily: 'MontserratLight',
    color: '#878787',
  },
  factsWrapper: {
    marginTop: 40,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}));

function TextualSection() {
  const classes = useStyles();

  const facts = [
    {
      id: '1',
      value: 50,
      text:
        'Of adults experience mental health conditions in their lifetime, 1 in 5 each year',
    },
    {
      id: '2',
      value: 70,
      text:
        'Gap between the need for mental health treatment and available resources',
    },
    {
      id: '3',
      value: 75,
      text: 'Who attempt to work on mental health issues do so on their own',
    },
    {
      id: '4',
      value: 95,
      text: 'Of self-help resources are not validated',
    },
    {
      id: '5',
      value: 98,
      text:
        'Of individuals recognize self-care as important to improving and maintaining their mental health',
    },
  ];

  return (
    <section id="stats-section">
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <LazyAnimation type="scale-up-80">
            <Typography className={classes.header}>
              It’s Time to De-stigmatize Mental Health Challenges
            </Typography>
          </LazyAnimation>
          <LazyAnimation type="scale-up-80">
            <Typography className={classes.body}>
              Mental and emotional distress is a growing crisis worldwide. It’s
              a drain on employer productivity, a driver of increasing
              healthcare costs, and it creates unnecessary suffering in our
              communities. Hospitals, health departments, employers, and
              coalitions are assessing the issues within their populations and
              identifying mental and behavioral health as a key priority across
              the board.
            </Typography>
            <Typography className={classes.body}>
              But what is a practical approach to addressing these problems?
            </Typography>
          </LazyAnimation>
          <div className={classes.factsWrapper}>
            {facts.map(fact => (
              <FactAnimation
                value={fact.value}
                text={fact.text}
                key={fact.id}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default TextualSection;
